/* The agent whose chat was opened last, so the retired /playground URL can land
 * somewhere useful. A per-browser convenience: storage can be missing or throw
 * (private windows, blocked site data), and every caller copes with null. */
const LAST_CHAT_AGENT_KEY = "forgedock.last-chat-agent";

export function getLastChatAgent(): string | null {
	try {
		return window.localStorage.getItem(LAST_CHAT_AGENT_KEY) || null;
	} catch {
		return null;
	}
}

export function setLastChatAgent(slug: string): void {
	try {
		window.localStorage.setItem(LAST_CHAT_AGENT_KEY, slug);
	} catch {
		// Unavailable storage only costs the /playground shortcut.
	}
}
